class ValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LocalLogicTracking/ValidationError";
  }
}

export { ValidationError };
